import { css } from '@emotion/css';

const container = css`
  @media (min-width: 769px) {
    position: fixed;
    top: 1rem;
    right: 2rem;
    z-index: 50;
  }

  @media (max-width: 768px) {
    position: static;
    display: flex;
    justify-content: flex-end;
    padding: 1rem;
  }
`;

const wrapper = css`
  display: flex;
  align-items: center;
  gap: 1.75rem;
`;

const closeIcon = css`
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: var(--colors-neutral-150);
  }
`;

const HeaderActionsStyles = {
  container,
  wrapper,
  closeIcon,
};

export default HeaderActionsStyles;
